import { toast } from "@climatepartner/components/Toast";
import { useEffect } from "react";

import { takeInterruptedChange } from "../../shared/api/interrupted-change";

// POST also serves reads (country matching, emission-factor search, upload previews), so the
// notice must not claim that anything was lost.
export const interruptedChangeMessage =
  "Your session expired while a request was still in progress. Please check that your last action went through.";

/** Render after `<Toast />`, so the toaster is listening when this effect runs. */
export const InterruptedChangeNotice = (): null => {
  useEffect(() => {
    if (takeInterruptedChange()) {
      toast.warning(interruptedChangeMessage);
    }
  }, []);

  return null;
};
